import { exhaustive } from "exhaustive"
import type { GroupRenderer, MergedGroup } from "../../events/messageGroups"
import { activityRenderer } from "./activityRenderer"
import { agentActivityRenderer } from "./agentActivityRenderer"
import { bashRenderer } from "./bashRenderer"
import { editRenderer } from "./editRenderer"
import { fileChangeRenderer } from "./fileChangeRenderer"
import { orchestrationRenderer } from "./orchestrationRenderer"
import { providerNoticeRenderer } from "./providerNoticeRenderer"
import { resultRenderer } from "./resultRenderer"
import { stderrRenderer } from "./stderrRenderer"
import { systemRenderer } from "./systemRenderer"
import { textRenderer } from "./textRenderer"
import { thinkingRenderer } from "./thinkingRenderer"
import { todoWriteRenderer } from "./todoWriteRenderer"
import { toolRenderer } from "./toolRenderer"
import { unknownRenderer } from "./unknownRenderer"
import { writeRenderer } from "./writeRenderer"

// The generic renderer type is intentionally erased at this discriminated lookup boundary.
export function getRenderer(group: MergedGroup): GroupRenderer<any> {
    return exhaustive.tag(group, "type", {
        text: () => textRenderer,
        thinking: () => thinkingRenderer,
        tool: () => toolRenderer,
        edit: () => editRenderer,
        write: () => writeRenderer,
        fileChange: () => fileChangeRenderer,
        bash: () => bashRenderer,
        orchestration: () => orchestrationRenderer,
        system: () => systemRenderer,
        result: () => resultRenderer,
        stderr: () => stderrRenderer,
        unknown: () => unknownRenderer,
        activity: () => activityRenderer,
        providerNotice: () => providerNoticeRenderer,
        agentActivity: () => agentActivityRenderer,
        todoWrite: () => todoWriteRenderer,
    })
}
